export function CharacterSkeleton() {
  return (
    <div className='grid p-[20px] shadow bg-white dark:bg-dark-9 gap-y-[20px] w-[260px] card z-[1] animate-pulse dark:border-purple'>
      <div className='w-[220px] h-[220px] bg-gray dark:bg-dark-9 rounded-full' />
      <div
        className='w-full h-[10px] bg-gray dark:bg-dark-9 mt-[20px] '
        style={{
          width: `${Math.random() * 50 + 30}%`,
        }}
      />
      <div className='flex justify-between'>
        <div
          className='h-[12px] bg-gray dark:bg-dark-9'
          style={{
            width: Math.random() * 60 + 20,
          }}
        />
        <div className='w-[40px] h-[10px] bg-gray dark:bg-dark-9' />
      </div>
      <div className='flex justify-between'>
        <div className='w-[80px] h-[12px] bg-gray dark:bg-dark-9' />
        <div className='w-[60px] h-[10px] bg-gray dark:bg-dark-9' />
      </div>
      <div className='w-full h-[4px]  bg-gray dark:bg-dark-9' />
      <div className='w-[100px] h-[10px]  bg-gray dark:bg-dark-9' />
    </div>
  )
}
